import { WarningIcon } from "../../../../../components/Icons/Icons";
import {
  Assets,
  PIMProduct,
  ProductFormSchema,
} from "../../../../../types/types.PIM";
import { DocumentsOrDigitalMediaTable } from "../../../ProductDetailPage/Assets/DocumentsOrDigitalMediaTable/DocumentsOrDigitalMediaTable";
import {
  ActiveWarningMessage,
  NotificationContainer,
} from "../../../SellerQuoteDetailPage/SellerQuoteDetailPageContent";
import { useTranslation } from "react-i18next";
import { WithPagination } from "../../../../../types/types";
import useSWR from "swr";
import { AxiosError } from "axios";
import { makeUrlWithParams, useStoreState } from "../../../../../util/util";
import { SetStateAction, Dispatch, useEffect, useState } from "react";
import { endpoints } from "../../../../../endpoints";
import { Loader } from "../../../../../components/Loader/Loader";
import { spacingTokens } from "../../../../../designTokens";

export const DocumentsStep = ({
  formData,
  productId,
  setRequiredDocsCategories,
}: {
  formData: ProductFormSchema;
  productId: string;
  setRequiredDocsCategories: Dispatch<SetStateAction<string[]>>;
}) => {
  const [product, setProduct] = useState<PIMProduct>();
  const [requiredDocumentsCategories, setRequiredDocumentsCategories] =
    useState<string[]>([]);
  const { t } = useTranslation();
  const { tenant_id } = useStoreState();

  const { data: productData, mutate: mutateProductData } = useSWR<PIMProduct>(
    productId
      ? makeUrlWithParams(
          endpoints.v2_tenants_id_pim_products_id(tenant_id, productId),
          {
            use_database: "true",
          }
        )
      : null,
    {
      revalidateOnFocus: false,
    }
  );

  const { data: assets, mutate: mutateAssetsData } = useSWR<
    WithPagination<{ data: Assets[] }>,
    AxiosError
  >(
    `/v2/tenants/${tenant_id}/pim/products/${productId}/assets?asset_type=document&limit=${300}&offset=${0}`
  );
  useEffect(() => {
    if (assets) {
      const requiredDocumentsCategories =
        formData.form.steps
          .find((step) => step.is_document_step === true)
          ?.categories?.filter(
            (category) =>
              !assets?.data?.some((asset) => asset.category.id === category.id)
          )
          .map((category) => category.name) ?? [];
      setRequiredDocumentsCategories(requiredDocumentsCategories);
      setRequiredDocsCategories(requiredDocumentsCategories);
    }
  }, [assets, formData.form.steps, setRequiredDocsCategories]);

  useEffect(() => {
    if (productData) {
      setProduct(productData);
      mutateAssetsData();
    }
  }, [productData, mutateAssetsData]);

  return (
    <div>
      {requiredDocumentsCategories.length > 0 && (
        <NotificationContainer style={{ alignItems: "flex-start" }}>
          <WarningIcon width={18} height={18} />
          <ActiveWarningMessage>
            <b>{t("Required Documents")}</b>
            <ul
              style={{
                paddingLeft: spacingTokens.spacing_none,
                margin: "10px 0 0 0",
              }}
            >
              {requiredDocumentsCategories.map((category) => (
                <li key={category}>{category}</li>
              ))}
            </ul>
          </ActiveWarningMessage>
        </NotificationContainer>
      )}
      {!product ? (
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Loader omitContainer={true} isLoading={!product} />
        </div>
      ) : (
        <>
          <div style={{ display: "flex", justifyContent: "flex-end" }}></div>
          <DocumentsOrDigitalMediaTable
            title={"Documents"}
            product={product}
            fetchProductData={mutateProductData}
            replaceProductId={() => {
              mutateAssetsData();
            }}
            isOutsideLogin={false}
            isShowTableWithBulkAction={false}
            isShowGridAssetWithBulkAction={false}
            hideViewToggle={true}
            hideFilters={true}
            showSearch={true}
            hideAddButton={true}
            showAddButtonAtTop={true}
            uploadNewDocumentsOnly={true}
            hideHeader={true}
            hideShareIcon={true}
            hideAccessibility={true}
            allowUpload={true}
            enableSave={true}
          />
        </>
      )}
    </div>
  );
};
